import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {orangeLight} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  header: {
    marginTop: 30,
    marginBottom: indent,
    flexDirection: 'row',
  },
  headerText: {
    paddingLeft: indent,
    justifyContent: 'center',
  },
  progress: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: indent / 2,
  },
  progressBarContainer: {
    width: 60,
    marginRight: indent / 2,
  },
  progressBarFill: {
    backgroundColor: orangeLight,
  },
});
